import React from "react"
import {currency} from "../utils/format"

const Plans = ({plans, selectPlan, lang}) => {
  const renderPlans = plans.map((plan, index) => {
    return <div className={`col-md-4 ${!index ? '' : ''}`}>
      <div className="plans-price_tab">
        <div className="pad">
          <h5 className="plans-name text-center">{plan.desc}</h5>
          <div className="text-center"><span className="txt-top rm">RM</span><span className="txt-l discounted-price">{plan.total}</span></div>
          <div className="price">/{lang.annual}</div>
        </div>
        <div className="text-center benefits">
          <div>{lang.coverage} </div>
          <div className="bold">RM {currency(plan.sumInsured, true).substr(2)}</div>
        </div>
        <div className="text-center benefits2">
          <div>{lang.limitPerItem}</div>
          <div className="bold">RM {currency(plan.limitPerItem, true).substr(2)}</div>
        </div>
        <div className="button-box">
          <button type="button" onClick={() => selectPlan(plan)} className="btn btn-red ghost mt-3 mb-3">{lang.buyNow}</button>
        </div>
      </div>
    </div>
  })

  return <>
    {renderPlans}
  </>
}

export default Plans